import { APP_ERROR_CODE, SdkError } from '../interface';
import { SdkResponseCode } from '../constant';

/**
 * 自动处理未实现的方法
 * @param _target 目标对象
 * @param _propKey 属性名
 * @param descriptor 属性描述符
 */
export function autoUnimplemented(_target: any, _propKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
        return new Promise((resolve, reject) => {
            originalMethod
                .apply(this, args)
                .then(resolve)
                .catch((err: any) => {
                    if (err.code === APP_ERROR_CODE.METHOD_NOT_FOUND) {
                        reject(
                            new SdkError(
                                this.sdkType,
                                SdkResponseCode.Unimplemented,
                                'method not found'
                            )
                        );
                    } else {
                        reject(err);
                    }
                });
        });
    };
}
